import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { ConsultationServiceComboboxItem } from "@customTypes/index";

import { clinicQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: ConsultationServiceComboboxItem[] = [];

    for (const i in res.data) {
      const { name, _id, category } = res.data[i];

      newData.push({
        value: _id,
        label: name,
        category,
      });
    }
    // console.log(newData);
    return newData;
  }
  return null;
};

interface QueryProps {
  category?: string;
}

export const useGetClinicConsultationServices = (options?: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: clinicQKeys.consultationServicesWithFilters({
      category: options?.category,
      status: "active",
    }),
    queryFn: () => {
      return api.get("clinic/consultation-services", {
        params: {
          status: "active",
          ...(options?.category && { category: options?.category }),
        },
      });
    },
    select,
    staleTime: Infinity, // Relatively long stale time because it does not change often

    onError: (res: any) => {
      console.error("[From Get Clinic consultation services]", res);
      handleErrors(res, "query");
    },
  });
};
